import { render, staticRenderFns } from "./ProfileSelector.vue?vue&type=template&id=86bdfc1a&scoped=true&"
import script from "./ProfileSelector.vue?vue&type=script&lang=js&"
export * from "./ProfileSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bdfc1a",
  null
  
)

export default component.exports